import { Dashboards } from '../../features/projectPlan/Dashboards';

export const DashboardsPage = () => <Dashboards />;
